<div>

  <div [class]="'lib-badge ' + categoryAlias + ' lib-elevation-1'" [hidden]="toggle.hidden">

    <lib-icon *ngIf="categoryAlias === 'rare-find' || categoryAlias === 'hidden-gem'" name="diamond"></lib-icon>

    <span>{{category}}</span>

    <span *ngIf="categoryAlias === 'over-valued'">~{{offsetValue | shortNumber}}</span>
    <span *ngIf="categoryAlias === 'over-valued'" class="percentage">{{offsetValuePercent | percent}}</span>

  </div>

</div>
